import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, TextField, Grid, Link } from '@material-ui/core';

import i18n from 'i18next';

const useStyles = makeStyles((theme) => ({
  root: {},
  margin: {
    margin: theme.spacing(1, 0),
  },
  header: {
    marginBottom: 16,
  },
}));

const VerificationForm = ({
  values: { code },
  errors,
  touched,
  handleSubmit,
  handleChange,
  isValid,
  setFieldTouched,
  setFieldValue,
  validateForm,
  errorMessage = '',
  onResendCode,
  onBackToLoginClick,
  codeSentMessage = '',
}) => {
  const classes = useStyles();

  const change = async (event) => {
    event.persist();
    const target = event.target;

    setFieldTouched(target.id, true, false);
    await handleChange(event);

    if (!isValid) {
      validateForm();
    }
  };

  return (
    <div className={classes.root}>
      <header className={classes.header}>
        <Typography variant="h2">{i18n.t('verification:title')}</Typography>
        {errorMessage && (
          <Typography variant="subtitle1" color="error">
            {errorMessage}
          </Typography>
        )}
        {codeSentMessage && (
          <Typography variant="subtitle1">{codeSentMessage}</Typography>
        )}
      </header>
      <form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <TextField
          id="code"
          name="code"
          variant="outlined"
          className={classes.margin}
          margin="dense"
          label={i18n.t('verification:form:code:label')}
          fullWidth
          value={code}
          onChange={change}
          helperText={touched.code ? errors.code : ''}
          error={touched.code && Boolean(errors.code)}
        />
        <Link
          type="button"
          component="button"
          color="error"
          href="/login"
          onClick={(e) => {
            setFieldValue('code', '');
            onResendCode(e);
          }}
        >
          {i18n.t('verification:links:resend')}
        </Link>
        <Grid container>
          <Grid item xs={12} sm={6}>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.margin}
              type="submit"
              disabled={!isValid}
            >
              {i18n.t('verification:form:buttons:submit')}
            </Button>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Button
              fullWidth
              color="primary"
              className={classes.margin}
              type="button"
              onClick={onBackToLoginClick}
            >
              {i18n.t('verification:form:buttons:cancel')}
            </Button>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

VerificationForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  isValid: PropTypes.bool,
  touched: PropTypes.shape({}),
  setFieldTouched: PropTypes.func,
  values: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  errorMessage: PropTypes.string,
  validateForm: PropTypes.func,
  onResendCode: PropTypes.func,
  onBackToLoginClick: PropTypes.func,
  setFieldValue: PropTypes.func,
  codeSentMessage: PropTypes.string,
};

export default VerificationForm;



// WEBPACK FOOTER //
// ./src/components/Login/VerificationForm.js